import { render, staticRenderFns } from "./onepageSlideDetailDialog.vue?vue&type=template&id=dd6c230e"
import script from "./onepageSlideDetailDialog.vue?vue&type=script&lang=js"
export * from "./onepageSlideDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports